import cx from 'classnames';
import React from 'react';

import styles from './JobStatusTag.module.scss';

export type JobStatusTagVariant = 'new' | 'default';

interface JobStatusTagProps {
  label: string;
  variant?: JobStatusTagVariant;
  className?: string;
}

const JobStatusTag = ({ label, variant = 'default', className }: JobStatusTagProps) => (
  <span
    className={cx(styles.tag, variant === 'new' ? styles.new : styles.default, className)}
    data-testid="job-status-tag"
  >
    {label}
  </span>
);

export default JobStatusTag;
